import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Cargando...</div>;
}

const UserTableContainer = Loadable({
    loader: () => import('../../Containers/User/UserTableContainer'),
    loading: Loading,
});
const CreateUserContainer = Loadable({
    loader: () => import('../../Containers/User/CreateUserContainer'),
    loading: Loading,
});
const EditUserContainer = Loadable({
    loader: () => import('../../Containers/User/EditUserContainer'),
    loading: Loading,
});

const userRoutes = [
    { path: '/user/list', name: 'Administración de Usuarios', component: UserTableContainer },
    { path: '/user/create', exact: true, name: 'Nuevo usuario', component: CreateUserContainer },
    { path: '/user/:id/edit', exact: true, name: 'Modificar usuario', component: EditUserContainer },
];

export default userRoutes;


// WEBPACK FOOTER //
// ./src/Routes/Modules/user.js